module.exports = __webpack_public_path__ + "img/renliziyuanhoutai.e2da5f85.png";